import React , {useState , useEffect, Fragment} from 'react';
import EditorAction from '../../../../actions/EditorAction';
import { useConversationStateContext } from '/src/features/chatbox/context/ConversationContext';
import * as purify from 'dompurify';

import { useState } from 'react';
import ChatImage from "./ChatImage.js" 

function MessagePart({ content}) {
    const [displayedContent, setDisplayedContent] = useState('');
    const [currentIndex, setCurrentIndex] = useState(0);
    const [prevContent, setPrevContent] = useState('');
  
    useEffect(() => {
      if (content !== prevContent) {
        setPrevContent(content);
        setCurrentIndex(0); 
      }
  
      let interval;
  
      if (currentIndex < content.length) {
        interval = setInterval(() => {
          setDisplayedContent(content.substring(0, currentIndex + 1));
          setCurrentIndex((prevIndex) => prevIndex + 1);
        }, 75); 
      }
  
      return () => clearInterval(interval);
    }, [currentIndex]);
  
    return (
      <span className='bubble' dangerouslySetInnerHTML={{ __html: purify.sanitize(displayedContent, { sanitize: true })  }} />
    );
}
const ErrorLink = ({block_id}) => {
    const {chatboxColor}=useConversationStateContext();
    const { ifFollowBlockDefinedMoveCamera } = EditorAction()
    return <a onClick={() => ifFollowBlockDefinedMoveCamera(block_id)} style={{color:chatboxColor}}>{block_id}</a>
}

const BuildError = ({content}) => {
    const regex = /[0-9]{13}_[0-9]{3,8}/;
    const match = content.match(regex);
    if(match == undefined) {
        return content;
    }

    const text = content.split(match[0]);
    return (
        <>
            {text[0]}
            <ErrorLink block_id={match[0]}/>
            {text[1]}
        </>
    )
}

const  BubbleChat = ({ content, type}) => {
    const {chatboxColor} = useConversationStateContext();

    const isUrl = (str) => {
      try {
          new URL(str);
          return true;
      } catch (_) {
          return false;
      }
    };

    const renderContent = () => {
      if (type === 'text' && isUrl(content)) {
          return (
            <span className='bubble'> 
              <a href={content} target="_blank" rel="noopener noreferrer"> {content} </a>
            </span>
          );
      } else if (type === 'text') {
        const regexImg = /<img[^>]*src="([^"]+)"[^>]*>/;
        const match = content.match(regexImg);
          return (
            match ? <span className='bubble'> <ChatImage content={content} /></span> : <span className='bubble' dangerouslySetInnerHTML={{ __html: content}} />
          );
      } else {
          return null; 
      }
    };

    var bubbles = type == 'text' ? content.split('§').filter(a => a) : [content];
    return bubbles.map((content, index) => {

      return (
        <Fragment key={index}>
          {renderContent()}
          {type == 'media'  ? <span className='bubble'><img srcSet={content}/></span> : ''}
          {type == 'error'  ? <span className='bubble'><BuildError content={content}/></span> : ''}
          {type == 'human'  ? <span className='bubble' style={{backgroundColor: chatboxColor ,display:"flex"}} dangerouslySetInnerHTML={{ __html: purify.sanitize(content, { sanitize: true }) }}/> : ''}
          {type == 'typing' ? <span className='bubble typing'><div className="dot"></div><div className="dot"></div><div className="dot"></div></span> : ''}
          {type == 'audio' ? <span className='bubble'><audio controls src={content}></audio></span> : ''}
        </Fragment>
      );
    });
};


function transformContent(content) {
  const regexImg = /<img[^>]*src="([^"]+)"[^>]*>/g;
  let result = "";
  let lastIndex = 0;
  let match;

  while ((match = regexImg.exec(content)) !== null) {
    // Texte avant l'image
    if (match.index > lastIndex) {
      result += content.slice(lastIndex, match.index);
    }

    const src = match[1];
    // Ici on reconstruit une balise <img> en string avec les attributs qu'on veut
    result += `<img 
      src="${src}" 
      alt="chat-img"
      class="inline-block max-w-[150px] max-h-[150px] rounded-lg cursor-pointer transition-all duration-300"
      onclick="if(this.classList.contains('max-w-[150px]')) { 
        this.classList.remove('max-w-[150px]', 'max-h-[150px]'); 
        this.classList.add('max-w-[90%]', 'max-h-[90vh]'); 
      } else { 
        this.classList.remove('max-w-[90%]', 'max-h-[90vh]'); 
        this.classList.add('max-w-[150px]', 'max-h-[150px]'); 
      }"
    />`;

    lastIndex = regexImg.lastIndex;
  }

  // Texte après la dernière image
  if (lastIndex < content.length) {
    result += content.slice(lastIndex);
  }

  return result;
}



BubbleChat.defaultProps = {
    content : '',
    type : 'text'
}

export default BubbleChat;